<template>
  <div>
    <header class="app-header">
      <router-link class="app-header__logo" to="/"><img class="d-none d-md-inline" src="../assets/logo.png" alt="Phonenet"/><img class="d-md-none" src="../assets/logo-icon.png" alt="Phonenet"/></router-link>
      <a class="app-sidebar__toggle" href="#" data-toggle="sidebar" aria-label="Menu">
        <font-awesome-icon icon="bars"/>
      </a>
      <!-- Navbar Right Menu-->
      <ul class="app-nav">
        <b-nav-item-dropdown right :toggle-class="$store.state.user.avatar ? 'app-nav__item p-0' : 'app-nav__item'" :style="$store.state.user.avatar ? 'padding-top: 11px' : ''">
          <template slot="button-content">
            <img v-if="$store.state.user.avatar" :src="$store.state.user.avatar" class="rounded-circle border border-light" style="height: 30px; width: 30px;" alt="Avatar" />
            <font-awesome-icon v-else icon="user" size="lg"/>
            <span class="d-none d-lg-inline ml-1">
              {{ this.$store.state.user.name }}
              ({{$t(this.$store.state.user.role)}} <span v-if="$store.state.user.expireTime" > - {{$store.state.user.expireTime | moment('DD/MM/YYYY')}}</span>)
            </span>
          </template>
          <b-dropdown-item @click="profile">
            <font-awesome-icon icon="user"/>
            {{ $t('profile') }}
          </b-dropdown-item>
          <b-dropdown-item @click="password">
            <font-awesome-icon icon="key"/>
            {{ $t('changePassword') }}
          </b-dropdown-item>
          <b-dropdown-item @click="logout">
            <font-awesome-icon icon="sign-out-alt"/>
            {{ $t('logOut') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>
    </header>
    <!-- Sidebar menu-->
    <div class="app-sidebar__overlay" data-toggle="sidebar"></div>
    <aside class="app-sidebar">
      <ul class="app-menu">
        <template v-for="item in menuItems">
          <router-link v-if="!item.items && item.href && checkRole(item.roles)" :key="item.href" :to="item.href" v-slot="{ href, navigate, isExactActive }">
            <li>
              <a :class="[isExactActive ?'active':'','app-menu__item']" :href="href" @click="navigate">
                <span class="app-menu__icon">
                  <font-awesome-icon :icon="item.icon"/>
                </span>
                <span class="app-menu__label">{{ item.name }}</span>
              </a>
            </li>
          </router-link>
          <li v-else-if="item.items && checkRole(item.roles)" :key="item.index" class="treeview">
            <a class="app-menu__item" href="#" data-toggle="treeview">
                            <span class="app-menu__icon">
                                <font-awesome-icon :icon="item.icon"/>
                            </span>
              <span class="app-menu__label">{{ item.name }}</span><i class="treeview-indicator fa fa-angle-right"></i>
            </a>
            <ul class="treeview-menu">
              <router-link v-for="i in item.items" :key="i.name" :to="i.href" v-slot="{ href, navigate, isExactActive }">
                <li v-if="checkRole(i.roles)">
                  <a :class="[isExactActive ?'active':'','treeview-item']" :href="href" @click="navigate">
                    <i class="icon fa fa-circle-o"></i> {{ i.name }}
                  </a>
                </li>
              </router-link>
            </ul>
          </li>
        </template>
      </ul>
      <lang></lang>
    </aside>
  </div>
</template>

<script>
import Lang from "../components/Lang";
import $ from 'jquery';

export default {
  components: {Lang},
  computed: {
    menuItems: function () {
      return [
        {name: this.$t('dashboard'), href: '/', icon: 'tachometer-alt'},
        {
          name: this.$t('report'), href: "/report/customer", icon: 'chart-bar',
          roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant','supervisor', 'manager', 'am', 'marketingManager', 'marketing'],
          items: [
            {name: this.$t('clientReport'), href: '/report/client',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant','supervisor', 'manager', 'am', 'marketingManager']},
            {name: this.$t('referralReport'), href: '/report/referral',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant','supervisor', 'manager', 'am', 'marketingManager']},
            {name: this.$t('contractReport'), href: '/report/contract',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant','supervisor', 'manager', 'am', 'marketingManager']},
            {name: this.$t('creditBalance'), href: '/report/credit-balance',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager']},
            {name: this.$t('callReport'), href: '/report/call',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant','supervisor', 'manager', 'am', 'marketingManager']},
            {name: this.$t('callFeeOverview'), href: '/report/call-fee-overview',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager']},
            {name: this.$t('callFeeDetail'), href: '/report/call-fee-detail',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager']},
            {name: this.$t('callPackage'), href: '/report/call-package',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager', 'manager']},
            {name: this.$t('planOrder'), href: '/report/plan-order',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant','supervisor', 'manager', 'am', 'marketingManager']},
            {name: this.$t('promotionOnOrder'), href: '/report/promotion',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant','supervisor', 'manager', 'am', 'marketingManager']},
            {name: this.$t('finance'), href: '/report/finance'},
            {name: this.$t('usageReport'), href: '/report/usage',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant','supervisor', 'manager', 'am', 'marketingManager']},
            {name: this.$t('quantityReport'), href: '/report/quantity',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant','supervisor', 'manager', 'am', 'marketingManager']},
          ]
        },
        {
          name: this.$t('finance'), href: "/credit-deposit", icon: 'credit-card',
          roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant','supervisor', 'manager', 'am', 'marketingManager'],
          items: [
            {name: this.$t('creditDeposit'), href: '/credit-deposit', icon: 'credit-card'},
            {name: this.$t('creditTransaction'), href: '/credit-transaction', icon: 'history'},
            {name: this.$t('planOrder'), href: '/plan-order', icon: 'flag'},
            {name: this.$t('clientPackage'), href: '/client-package', icon: 'flag'},
            {name: this.$t('clientCDP'), href: '/client-cdp', icon: 'flag'},
            {name: this.$t('aiAgentOrder'), href: '/client-chatbot'},
            {name: this.$t('invoicePlanOrder'), href: '/invoice-plan-order'},
            {name: this.$t('phoneNumberSetupTransaction'), href: '/phone-number-setup-transaction', icon: 'flag',
              roles: ['owner','admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']},
            {name: this.$t('phoneNumberSubscriptionTransaction'), href: '/phone-number-subscription-transaction', icon: 'flag',
              roles: ['owner','admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']},
            {name: this.$t('smsBrandNameRegisterTransaction'), href: '/sms-brand-name-register-transaction', icon: 'flag',
              roles: ['owner','admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']},
            {name: this.$t('smsBrandNameSubscriptionTransaction'), href: '/sms-brand-name-subscription-transaction', icon: 'flag',
              roles: ['owner','admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']},
            {name: this.$t('numberBrandNameSetupTransaction'), href: '/number-brand-name-setup-transaction', icon: 'flag',
              roles: ['owner','admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']},
            {name: this.$t('numberBrandNameSubscriptionTransaction'), href: '/number-brand-name-subscription-transaction', icon: 'flag',
              roles: ['owner','admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']},
            {name: this.$t('callRefundSubscriptionTransaction'), href: '/call-refund-subscription-transaction', icon: 'flag',
              roles: ['owner','admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']},
            {name: this.$t('phoneNumberCommitTransaction'), href: '/phone-number-commit-transaction', icon: 'flag',
              roles: ['owner','admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']},
            {name: this.$t('viberBrandNameCommitTransaction'), href: '/viber-brandname-commit-transaction', icon: 'flag',
              roles: ['owner','admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']},
          ]
        },
        {
          name: this.$t('vatInvoice'), href: "/invoice-gateway", icon: 'receipt',
          roles: ['owner'],
          items: [
            {name: this.$t('supplier'), href: '/invoice-gateway'},
            {name: this.$t('plan'), href: '/invoice-plan'},
            {name: this.$t('setup'), href: '/invoice-setup'},
            {name: 'API Hilo', href: '/hilo-invoice-log'},
          ]
        },
        {
          name: this.$t('client'), href: "/client-manager", icon: 'user-tie', roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'lookup'],
          items: [
            {name: this.$t('client'), href: '/client', icon: 'user-tie'},
            {
              name: this.$t('invoiceInfo'),
              href: '/invoice-info',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant']
            },
            {
              name: this.$t('lead'), href: '/client-lead', icon: 'user-tie',
              roles: ['owner', 'admin', 'tech', 'sales', 'kpiSales', 'am', 'manager'],
            },
            {name: this.$t('clientRegister'), href: '/client-register', icon: 'key',
              roles: ['owner','admin', 'tech', 'sales', 'kpiSales', 'marketing', 'marketingManager', 'manager'],
            },
            {name: this.$t('clientKYC'), href: '/client-kyc', icon: 'key',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am'],
            },
            {name: this.$t('clientTrialExtendRequest'), href: '/client-trial-extend-request', icon: 'key',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am'],
            },
            {name: this.$t('plan'), href: '/plan', icon: 'cubes',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am'],
            },
             {name: this.$t('promotion'), href: '/promotion', icon: 'bullhorn', roles: ['owner','admin', 'account'],
            },
            {name: this.$t('callHistory'), href: '/call', icon: 'history',
              roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'lookup']},

          ]
        },
        {
          name: this.$t('phone'), href: "/host", icon: 'phone', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'am', 'marketingManager'], items: [
            {name: this.$t('phoneHost'), href: '/host', icon: 'server', roles: ['owner','admin', 'tech' , 'operationsManager']},
            {name: this.$t('gateway'), href: '/gateway', icon: 'server', roles: ['owner','admin', 'tech' , 'operationsManager', 'am', 'account']},
            {name: this.$t('phoneNetwork'), href: '/phone-network', icon: 'project-diagram', roles: ['owner','admin', 'tech' , 'operationsManager', 'am', 'account']},
            {name: this.$t('phoneNumber'), href: '/number', icon: 'phone'},
            {name: 'DNC', href: '/dnc', icon: 'ban', roles: ['owner','admin', 'tech' , 'operationsManager']},
            {name: this.$t('systemRecording'), href: '/system-recording', icon: 'headphones', roles: ['owner','admin', 'tech' , 'operationsManager']},
          ]
        },
        {
          name: this.$t('campaign'), icon: 'rocket', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'am', 'marketingManager'], items: [
            {name: this.$t('massCall'), href: '/call-campaign', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'am', 'marketingManager']},
            {name: this.$t('messageCampaign'), href: '/message-campaign', roles: ['owner','admin', 'tech' , 'operationsManager', 'account', 'am']},
            {name: this.$t('emailCampaign'), href: '/email-campaign', icon: 'inbox'},
          ]
        },
        {
          name: this.$t('aiCall'), href: '/ai-template', icon: 'robot', roles: ['owner','admin', 'tech', 'account', 'operationsManager'], items: [
            {name: 'Gateway', href: '/ai-gateway'},
            // {name: this.$t('aiTemplate'), href: '/ai-campaign'},
            // {name: this.$t('aiTemplate'), href: '/ai-template'},
            // {name: this.$t('aiHistory'), href: '/ai'},
          ]
        },
        {
          name: this.$t('message'), href: '/message-campaign', icon: 'sms', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'am', 'marketingManager'], items: [
            {name: 'SMS', href: '/sms'},
            {name: 'Viber', href: '/viber'},
            {name: 'ZNS', href: '/zns'},
            {name: 'Webhook Vietguys', href: '/webhook-vietguys', roles: ['owner', 'admin', 'tech', 'account', 'am']},
            {name: this.$t('socialNetworkAccounts'), href: '/social-network-account'},
            {name: this.$t('clientBot'), href: '/client-bot', roles: ['owner', 'admin', 'tech', 'account', 'am']},
            {name: this.$t('socialNetworkAccountsHistory'), href: '/social-network-account-history'},
            {name: this.$t('botDetectHistory'), href: '/bot-detect-history'},
            {name: this.$t('pointTransactionHistory'), href: '/point-transaction-history'},
            {name: this.$t('chatHistory'), href: '/chat-history'},
          ]
        },
        {
          name: this.$t('emailMarketing'), href: '/email-sender', icon: 'envelope', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'marketingManager'], items: [
            {name: this.$t('emailTemplate'), href: '/email-template-callio', icon: 'inbox'},
            {name: 'Email Sender', href: '/email-sender', icon: 'envelope'},
            // {name: 'Gateway', href: '/email-gateway', icon: 'inbox'},
            {name: this.$t('emailHistory'), href: '/email-history', icon: 'inbox'},
          ]
        },
        {
          name: 'Ecommerce', icon: 'shopping-cart', roles: ['owner','admin', 'tech', 'operationsManager', 'account', 'am', 'sales', 'kpiSales', 'manager', 'accountant'], items: [
            { name: this.$t('product'), href: '/admin-product'},
            { name: this.$t('order'), href: '/admin-order'},
          ]
        },
        {
          name: this.$t('faultDetection'), icon: 'bug', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'am', 'sales', 'kpiSales'], items: [
            {name: this.$t('keyword'), href: '/fault-detection-keyword', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'am', 'sales', 'kpiSales']},
            {name: this.$t('callFaultDetection'), href: '/fault-detection-call', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'am', 'sales', 'kpiSales']},
            {name: this.$t('chatFaultDetection'), href: '/fault-detection-chat', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'am']},
            {name: this.$t('ipFaultDetection'), href: '/fault-detection-ip', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'am', 'sales', 'kpiSales']},
          ]
        },
        {
          name: this.$t('lookup'), icon: 'search', roles: ['owner', 'admin', 'am', 'account', 'tech', 'operationsManager', 'lookup'], items: [
            {name: this.$t('adminCall'), href: '/lookup-call', roles: ['owner', 'admin', 'am', 'account', 'tech', 'operationsManager', 'lookup']},
            {name: this.$t('client'), href: '/lookup-customer', roles: ['owner', 'admin', 'am', 'account', 'tech', 'operationsManager', 'lookup']},
          ]
        },
        // {
        //   name: this.$t('commission'), icon: 'bullseye', roles: ['owner','admin', 'tech', 'account', 'operationsManager'], items: [
        //     {name: this.$t('adminUserCommission'), href: '/admin-user-commission', icon: 'bullseye'},
        //     {name: this.$t('commissionList'), href: '/commission', icon: 'bullseye'},
        //     {name: this.$t('kpiSetup'), href: '/kpi-setup', icon: 'bullseye', roles: ['owner','admin', 'account', 'operationsManager']},
        //   ]
        // },
        {
          name: this.$t('aiAdminCall'), icon: 'robot', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'ctvCall', 'am'], items: [
            {name: this.$t('report'), href: '/admin-call-report', roles: ['owner','admin', 'tech', 'account', 'operationsManager']},
              {name: this.$t('adminCall'), href: '/admin-call', roles: ['owner','admin', 'tech', 'account', 'operationsManager']},
            {name: this.$t('adminCalltranslate'), href: '/admin-call-translate', roles: ['owner','admin', 'tech', 'account', 'operationsManager', 'ctvCall', 'am']},
          ]
        },
        {
          name: this.$t('adminUser'), icon: 'users', roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager'], items: [
            {name: this.$t('adminUser'), href: '/admin-user', roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager']},
            {name: this.$t('setupKPI'), href: '/admin-user-kpi', roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager']},
            {name: this.$t('department'), href: '/department', roles: ['owner','admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager']},
            {name: 'Category', href: '/category', icon: 'divide', roles: ['owner','admin'] },
          ]
        },
        {
          name: this.$t('setup'), icon: 'cogs', roles: ['owner', 'admin', 'tech', 'account', 'am', 'sales', 'kpiSales', 'manager'], items: [
            { name: this.$t('logisticsCompany'), href: '/carrier-gateway', roles: ['owner','admin', 'tech']},
            { name: this.$t('printTemplate'), href: '/print-template', roles: ['owner','admin', 'tech']},
            { name: this.$t('country'), href: '/country', icon: 'globe', roles: ['owner','admin', 'tech']},
            { name: this.$t('parameter'), href: '/etc', icon: 'cog', roles: ['owner', 'admin', 'tech']},
            { name: 'Popup', href: '/admin-popup', icon: 'globe', roles: ['owner','admin', 'tech']},
            { name: 'Tiện ích', href: '/tool', icon: 'wrench', roles: ['owner', 'admin', 'tech', 'account', 'am', 'manager']},
            { name: 'Gửi thông báo', href: '/error-notification', icon: 'error', roles: ['owner', 'admin', 'tech']},
            { name: 'Release Notes', href: '/release-note', icon: 'bullhorn', roles: ['owner', 'admin', 'tech']},
            { name: 'Vấn đề thường gặp', href: '/error', icon: 'error', roles: ['owner', 'admin', 'tech', 'account', 'am', 'sales', 'kpiSales']},
            { name: this.$t('mappingZaloUser'), href: '/mapping-zalo-user', roles: ['owner', 'admin', 'tech']},
            { name: this.$t('activityHistory'), href: '/activity-history', roles: ['owner', 'admin', 'tech', 'account'] },
            { name: 'Sitemap', href: '/sitemap'},
          ]
        },
        {
          name: 'AI Trợ lý', icon: 'robot', roles: ['owner', 'admin', 'tech', 'account', 'operationsManager'], items: [
            {name: 'Tổng quan', href: '/ai-assistant'},
            {name: 'Lịch sử câu hỏi', href: '/ai-assistant-logs'},
          ]
        },
        { name: 'Token', href: '/token', icon: 'link'},
      ];
    }
  },
  i18n: {
    messages: {
      en: {
        promotions:'Promotion',
        dashboard: 'Dashboard',
        client: 'Client',
        clientRegister: 'Client register',
        clientKYC: 'Client KYC',
        callFeeOverview: 'Call fee overview',
        callFeeDetail: 'Call fee detail',
        plan: 'Plan',
        creditDeposit: 'Credit deposit',
        phoneNumber: 'Phone numbers',
        phoneHost: 'Phone hosts',
        country: 'Country',
        phoneNetwork: 'Phone network',
        adminUser: 'Admin users',
        profile: 'My profile',
        changePassword: 'Change password',
        logOut: 'Logout',
        systemRecording: 'System recording',
        creditTransaction: 'Credit transaction',
        report: "Report",
        clientReport: "Client",
        systemUsageReport: "System Usage",
        financeReport: "Finance",
        callReport: "Call",
        callTrafficReport: "Call traffic",
        customerReport: "Customer",
        sms: "SMS",
        emailMarketing: "Email",
        planOrder: "Plan order",
        subscriptionTransaction: "Subscription",
        callHistory: 'Call history',
        campaign: 'Campaign',
        smsHistory: 'SMS history',
        znsHistory: 'ZNS history',
        phoneNumberSetupTransaction: 'Phone number setup transaction',
        smsBrandNameRegisterTransaction: 'SMS brand name register transaction',
        phoneNumberSubscriptionTransaction: 'Phone number subscription transaction',
        smsBrandNameSubscriptionTransaction: 'SMS brand name subscription transaction',
        numberBrandNameSetupTransaction: 'Number brand name setup transaction',
        numberBrandNameSubscriptionTransaction: 'Number braVnd name subscription transaction',
        commissionConfig: 'Commission config',
        role: 'Role',
        department: 'Department',
        kpiSetup: 'KPI setup',
        commission: 'Commission',
        commissionList: 'Commission list',
        adminUserCommission: 'Employee commission',
        zns: 'ZNS',
        znsSupplier: 'ZNS Supplier',
        znsTemplate: 'ZNS Template',
        phone: 'Tele Phone',
        aiAPP: "AI APP",
        aiCall: "Auto call",
        aiTemplate: 'Call Template',
        cluster: "Cluster",
        flex: "Flex Package",
        faultDetection: "Fault Detection",
        callFaultDetection: "Suspicious call",
        keyword: "Keyword",
        viber: "Viber",
        viberHistory: "Viber history",
        creditBalance: "Credit Balance",
        message: "Message",
        messageCampaign: "Message campaign",
        phonebook: 'Phonebook',
        aiHistory: "History",
        contractReport: "Contract",
        parameter: "Parameter",
        emailCampaign: "Email Campaign",
        setupKPI: "Setup KPI",
        setup: "Setup",
        promotionOnOrder: "Promotion on orders",
        lead: 'Lead',
        emailTemplate: 'Template',
        phoneNumberCommitTransaction: "Phone number commit transaction",
        viberBrandNameCommitTransaction: "Viber brandName commit transaction",
        massCall: "Mass call",
        clientCDP: "CDP package",
        marketingManager: "Marketing Manager",
        referralReport: "Referral",
        emailHistory: "Email history",
        socialNetworkAccounts: "Social network account",
        planOrderByMonth: "Plan order by month",
        usageReport: 'Usage',
        callPackage: 'All-inclusive calling package',
        order: 'Order',
        printTemplate: 'Print template',
        logisticsCompany: 'Logistics company',
        chatSession: "Chat session",
        chatFaultDetection: "Suspicious chat",
        quantityReport: "Quantity",
        mappingZaloUser: 'List of personal Zalo customers',
        callRefundSubscriptionTransaction: "Refund of call charges",
        activityHistory: "Activity history",
        product: "Product",
        aiAdminCall: "Xử lý cuộc gọi AI",
        adminCall: "Cuộc gọi",
        adminCalltranslate: "Biên dịch",
        lookup: "Tra cứu",
        kpiSales: "KPI sales",
        aiAgentOrder: "AI agent order",
        clientBot: "Client Bot",
        socialNetworkAccountsHistory: "Social network account history",
        botDetectHistory: "Bot detect history",
        pointTransactionHistory: "Point transaction history",
        chatHistory: "Chat history",
        invoiceInfo: "Invoice info",
        sitemap: "Sitemap",
        vatInvoice: "Electronic invoice",
        supplier: "Supplier",
        invoicePlanOrder: "Electronic invoice order",
        ipFaultDetection: "Suspicious customers",
      },
      vi: {
        promotion: 'Khuyến mãi',
        keyword: 'Từ khóa',
        dashboard: 'Tổng quan',
        client: 'Khách hàng',
        clientRegister: 'Đăng ký dùng thử',
        clientKYC: 'Hồ sơ khách hàng',
        callFeeOverview: 'Cước gọi tổng quan',
        callFeeDetail: 'Cước gọi chi tiết',
        plan: 'Gói dịch vụ',
        creditDeposit: 'Lệnh nạp tiền',
        phoneNumber: 'Số điện thoại',
        phoneHost: 'Tổng đài',
        country: 'Quốc gia',
        phoneNetwork: 'Mạng',
        adminUser: 'Tài khoản',
        profile: 'Hồ sơ cá nhân',
        changePassword: 'Đổi mật khẩu',
        logOut: 'Thoát tài khoản',
        systemRecording: 'File ghi âm',
        creditTransaction: 'Lịch sử giao dịch',
        report: "Báo cáo",
        clientReport: "Khách hàng",
        systemUsageReport: "Sử dụng hệ thống",
        financeReport: "Tài chính",
        callReport: "Cuộc gọi",
        callTrafficReport: "Lưu lượng gọi",
        customerReport: "Khách hàng",
        sms: "SMS",
        emailMarketing: "Email",
        planOrder: "Đơn hàng gói dịch vụ",
        subscriptionTransaction: "Thuê bao hàng tháng",
        callHistory: 'Lịch sử gọi',
        campaign: 'Chiến dịch',
        smsHistory: 'Lịch sử SMS',
        znsHistory: 'Lịch sử ZNS',
        phoneNumberSetupTransaction: 'Phí khởi tạo số',
        smsBrandNameRegisterTransaction: 'Phí đăng ký SMS brandname',
        phoneNumberSubscriptionTransaction: 'Phí duy trì số',
        smsBrandNameSubscriptionTransaction: 'Phí duy trì brandname',
        numberBrandNameSetupTransaction: 'Phí khởi tạo brandname số',
        numberBrandNameSubscriptionTransaction: 'Phí duy trì brandname số',
        commissionConfig: 'Cài đặt hoa hồng',
        role: 'Phân quyền',
        department: 'Phòng ban',
        kpiSetup: 'Cài đặt KPI',
        commission: 'Hoa hồng',
        commissionList: 'Danh sách chi tiết',
        adminUserCommission: 'Hoa hồng nhân viên',
        zns: 'ZNS',
        znsSupplier: 'Nhà cung cấp ZNS',
        znsTemplate: 'Mẫu tin nhắn ZNS',
        phone: 'Điện thoại',
        aiAPP: "Bot gọi",
        aiCall: "Gọi tự động",
        aiTemplate: 'Mẫu cuộc gọi',
        cluster: "Cluster",
        flex: "Gói Flex",
        faultDetection: "Vi phạm",
        callFaultDetection: "Cuộc gọi nghi ngờ",
        viber: "Viber",
        viberHistory: "Lịch sử Viber",
        creditBalance: "Số dư khách hàng",
        message: "Tin nhắn",
        messageCampaign: "Chiến dịch tin nhắn",
        phonebook: 'Danh bạ số',
        aiHistory: "Lịch sử",
        contractReport: "Hợp đồng",
        parameter: "Tham số",
        emailCampaign: "Chiến dịch email",
        setupKPI: "Cài đặt KPI",
        setup: "Cài đặt",
        promotionOnOrder: "Khuyến mãi trên đơn hàng",
        lead: 'Tiềm năng',
        emailTemplate: 'Mẫu email',
        phoneNumberCommitTransaction: "Số điện thoại cam kết",
        viberBrandNameCommitTransaction: "Viber brandname cam kết ",
        massCall: "Gọi hàng loạt",
        clientCDP: "Đơn hàng gói CDP",
        marketingManager: "Quản lý Marketing",
        referralReport: "Giới thiệu",
        emailHistory: "Lịch sử email",
        socialNetworkAccounts: "Tài khoản mạng xã hội",
        planOrderByMonth: "Đơn hàng",
        usageReport: 'Sử dụng',
        callPackage: 'Gói gọi trọn gói',
        order: 'Đơn hàng',
        printTemplate: 'Mẫu in',
        logisticsCompany: 'Hãng vận chuyển',
        chatSession: "Phiên chat",
        chatFaultDetection: "Tin nhắn nghi ngờ",
        quantityReport: "Sản lượng",
        mappingZaloUser: "Danh sách KH Zalo cá nhân",
        callRefundSubscriptionTransaction: "Hoàn tiền cước gọi",
        activityHistory: "Lịch sử hoạt động",
        product: "Sản phẩm",
        aiAdminCall: "Xử lý cuộc gọi AI",
        adminCall: "Cuộc gọi",
        adminCalltranslate: "Biên dịch",
        lookup: "Tra cứu",
        kpiSales: "KPI sales",
        aiAgentOrder: "Đơn hàng nhân viên AI",
        clientBot: "Tài khoản tích hợp",
        socialNetworkAccountsHistory: "Lịch sử tài khoản mạng xã hội",
        botDetectHistory: "Lịch sử giám sát giao tiếp",
        pointTransactionHistory: "Lịch sử tích điểm",
        chatHistory: "Lịch sử chat",
        invoiceInfo: "Thông tin xuất hóa đơn",
        sitemap: "Sitemap",
        vatInvoice: "Hoá đơn điện tử",
        supplier: "Nhà cung cấp",
        invoicePlanOrder: "Đơn hàng hoá đơn điện tử",
        ipFaultDetection: "Khách hàng nghi ngờ",
      }
    }
  },
  methods: {
    checkRole: function (roles) {
      if (!roles || roles.length === 0) {
        return true;
      }
      if (roles.find(role => this.$store.state.user.role === role)) {
        return true;
      }
      return false;
    },
    logout: function () {
      sessionStorage.removeItem('token');
      localStorage.removeItem('token');
      this.$service.defaults.headers.common['token'] = null;
      this.$bgService.defaults.headers.common['token'] = null;
      this.$store.commit('user', null);
      this.$router.push('/login');
    },
    profile: function () {
      this.$store.commit('showProfileForm', true);
    },
    password: function () {
      this.$store.commit('showPasswordForm', true);
    },
  },
  mounted: function () {
    let treeviewMenu = $('.app-menu');
    let viewportGlobal = $(window).width();

    $('[data-toggle="sidebar"]').click(function (event) {
      event.preventDefault();
      $('.app').toggleClass('sidenav-toggled');
    });

    $("[data-toggle='treeview']").click(function (event) {
      event.preventDefault();
      if (!$(this).parent().hasClass('is-expanded')) {
        treeviewMenu.find("[data-toggle='treeview']").parent().removeClass('is-expanded');
        $(this).parent().addClass('is-expanded');
      } else {
        $(this).parent().removeClass('is-expanded');
      }
    });

    $("[data-toggle='treeview'].is-expanded").parent().toggleClass('is-expanded');
    $("[data-toggle='tooltip']").tooltip();

    if (viewportGlobal < 768) {
      $('.app-menu__item').click(function (event) {
        event.preventDefault();
        //$('.app').toggleClass('sidenav-toggled');
      });
    }

    setTimeout(function () {
      $('.app-menu a').each(function () {
        if ($(this).hasClass('active')) {
          $(this).parents('li.treeview').addClass('is-expanded');
        }
      });
    }, 300);
  }
};
</script>
